module.exports = __webpack_public_path__ + "static/media/nicotineActive.60d75533.svg";